import { useState } from 'react';
import { Button, Grid, MenuItem, Popover } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-final-form';
import { map } from 'lodash';

import SelectField from 'common/forms/SelectField';
import DateField from 'common/forms/DateField';
import { casingFormat } from 'common/utils';
import { filterReviewInClaimEligibilityLineItems } from 'store/thunks/workQueueThunks';

import { SortKey } from 'enums/common.enum';

const ReviewInClaimEligibilityFilterButton = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const filter = useSelector(({ workQueue: { reviewInClaimEligibility } }) => ({
    ...reviewInClaimEligibility.filter,
    requestedDate:
      reviewInClaimEligibility.filter?.requestedDate &&
      new Date(reviewInClaimEligibility.filter.requestedDate),
    shipByDate:
      reviewInClaimEligibility.filter?.shipByDate &&
      new Date(reviewInClaimEligibility.filter.shipByDate),
  }));

  const partners = useSelector(({ auth, partner }) => partner[auth.currentTenantId]);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const popoverId = anchorEl ? 'WorkQueue-ReviewInClaimEligibilityFilterButton-Popover' : undefined;

  const handleApplyFilter = (formData) => {
    setAnchorEl(null);

    dispatch(
      filterReviewInClaimEligibilityLineItems({
        filter: {
          ...formData,
          requestedDate: formData.requestedDate && formData.requestedDate.toISOString(),
          shipByDate: formData.shipByDate && formData.shipByDate.toISOString(),
        },
      })
    );
  };

  return (
    <>
      <Button
        sx={{ height: 33 }}
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>

      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Grid container sx={{ p: 1.5, width: 325 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={filter}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <SelectField
                      label='Partner Name'
                      name={SortKey.PARTNER_UUID}
                      id='WorkQueue-ReviewInClaimEligibilityFilterButton-partnerUuid-dropdown'
                    >
                      <MenuItem value=''>All</MenuItem>
                      {map(partners, ({ partnerName, partnerUuid }) => (
                        <MenuItem value={partnerUuid} key={partnerUuid}>
                          {casingFormat(partnerName)}
                        </MenuItem>
                      ))}
                    </SelectField>
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <DateField
                      label='Requested Date'
                      name={SortKey.REQUESTED_DATE}
                      id='WorkQueue-ReviewInClaimEligibilityFilterButton-requestedDate-dateField'
                      maxDate={new Date()}
                    />
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <DateField
                      label='Ship By Date'
                      name={SortKey.SHIP_BY_DATE}
                      id='WorkQueue-ReviewInClaimEligibilityFilterButton-shipByDate-dateField'
                    />
                  </Grid>

                  <Grid container justifyContent='flex-end'>
                    <Button variant='contained' type='submit' disabled={invalid}>
                      Apply
                    </Button>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default ReviewInClaimEligibilityFilterButton;
